{
  "testimonials": [
    {
      "name": "Amy Goldsberg",
      "role": "CEO at Coca Cola",
      "description": "Feucilius. At preprotious of cubile easus senectious various socis suspendecious integer suspendise tutpris serectum perefectureque nibh ioxulis.",
      "path": "/assets/images/home/testimonials/amy.png"
    },
    {
      "name": "John Jandali",
      "role": "CTO at Loom",
      "description": "Eros nulla mollis nec tortor. Eu class ante accumsan habitant morbi neque hac purus magnis varius pulvinar hac pede magnis.",
      "path": "/assets/images/home/testimonials/john.png"
    },
    {
      "name": "Lina Sloan",
      "role": "Content writer at Uber",
      "description": "Eros nulla mollis nec tortor. Eu class ante accumsan habitant morbi neque hac purus magnis varius pulvinar hac pede magnis.",
      "path": "/assets/images/home/testimonials/lina.png"
    },
    {
      "name": "Robert Sloan",
      "role": "CTO",
      "description": "Feucilius. At preprotious of cubile easus senectious various socis suspendecious integer suspendise tutpris serectum perefectureque nibh ioxulis.",
      "path": "/assets/images/home/testimonials/robert.png"
    },
    {
      "name": "Amy Goldsberg",
      "role": "CEO at Coca Cola",
      "description": "Feucilius. At preprotious of cubile easus senectious various socis suspendecious integer suspendise tutpris serectum perefectureque nibh ioxulis.",
      "path": "/assets/images/home/testimonials/amy.png"
    },
    {
      "name": "John Jandali",
      "role": "CTO at Loom",
      "description": "Eros nulla mollis nec tortor. Eu class ante accumsan habitant morbi neque hac purus magnis varius pulvinar hac pede magnis.",
      "path": "/assets/images/home/testimonials/john.png"
    },
    {
      "name": "Lina Sloan",
      "role": "Content writer at Uber",
      "description": "Eros nulla mollis nec tortor. Eu class ante accumsan habitant morbi neque hac purus magnis varius pulvinar hac pede magnis.",
      "path": "/assets/images/home/testimonials/lina.png"
    },
    {
      "name": "Robert Sloan",
      "role": "CTO",
      "description": "Feucilius. At preprotious of cubile easus senectious various socis suspendecious integer suspendise tutpris serectum perefectureque nibh ioxulis.",
      "path": "/assets/images/home/testimonials/robert.png"
    }
  ]
}
